import React, {useEffect, useState} from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {useParams} from "react-router-dom";
import {ParticipantForm} from "../../../components/admin/participant/ParticipantForm";
import {Loader} from "../../../components/admin/Loader";
import {ApiService} from "../../../service/ApiService";
import {raceHydrator} from "../../../models/hydrator/raceHydrator";
import {raceResultType} from "../../../types/Api/RaceResultType";
import {race} from "../../../models/race";
import {RaceCard} from "../../../components/admin/race/RaceCard";

export const Add = () => {
  const uuid: undefined | string = useParams().uuid;

  const [race, setRace] = useState(undefined as undefined | race);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/race/${uuid}`) as Promise<raceResultType>;

      setLoading(true);

      result
        .then((r) => {
          setRace(raceHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {(!loading && race) && (
        <>
          <BoxTitle title="Ajouter un participant"/>
          <RaceCard race={race} />
          <ParticipantForm race={race} />
        </>
      )}
    </>
  )
}
